// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2sYw7","header":"styles_header__1J2mg","main":"styles_main__2LPH4"};